export default __webpack_public_path__ + "epaper-colored.png";